import { formatDistanceToNow } from 'date-fns'

export const toDateOrNull = (value) => {
  if (!value) return null
  const parsedDate = new Date(value)
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
}

export const toUtcDateOrNull = (value) => {
  if (!value) return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
    const utcDate = new Date(value.replace(' ', 'T') + 'Z')
    return Number.isNaN(utcDate.getTime()) ? null : utcDate
  }

  return toDateOrNull(value)
}

export const formatFromNowOrEmpty = (value) => {
  const parsedDate = toDateOrNull(value)
  if (!parsedDate) return ''
  return formatDistanceToNow(parsedDate, { addSuffix: true })
}
